<template>
  <div id="app">
    <!--//首页入口-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!--//其他页入口-->
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      webAppId: "",
    };
  },
  created() {
    let path = this.$route.path;
    if (
      path == "/pages/preview/preview" ||
      path == "/pages/editbase/editbase"
    ) {
      return;
    }
    this.getWxConfig();
  },
  computed: {
    ...mapState(["hasLogin", "userInfo", "openId", "config", "follow"]),
  },
  methods: {
    ...mapMutations([
      "login",
      "setOpenId",
      "setConfig",
      "setOrgInfo",
      "setdomain",
      "setFollow",
    ]),
    getWxConfig() {
      this.$http.request(this.$http.pathMap.wxConfig).then((res) => {
        this.webAppId = res.data.appId;
        localStorage.setItem("appId", res.data.appId);
        localStorage.setItem("shopTitle", res.data.baseInfoName || "");
        this.setdomain(res.data.domain);
        const changeFavicon = (link) => {
          let $favicon = document.querySelector('link[rel="icon"]');

          if ($favicon !== null) {
            $favicon.href = link;
          } else {
            $favicon = document.createElement("link");
            $favicon.rel = "icon";
            $favicon.href = link;
            document.head.appendChild($favicon);
          }
        };
        const icon = res.data.baseInfoLogo; // 图片地址
        changeFavicon(icon); // 动态修改网站图标
        const title = res.data.baseInfoName; // 网站标题
        document.title = title; // 动态修改网站标题
        // let token = "eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJXZUNoYXROYW1lIiwidXNlcklkIjo2MjQsInRlbmFudElkIjoxLCJjdXJyZW50UmVhbE5hbWUiOiJXZUNoYXROYW1lIiwiY3VycmVudERlcHRJZCI6MCwidXNlclNjb3BlIjoibWFsbF9hcGkiLCJleHAiOjE2Njk3NDA4MDJ9.zQfxdEbed4mlSEpnkF7CMkaiXxZMyD-_Vc3rL45JCtvgvEO9o6s7gfVLeaYXAB5w2n_bEWBrPwoKskxvIAZ-LW-zNcbWrIBSg85L5vsVm3XslElajPNB8-OMSiUCpZQvpjg31e2oEwOdcRGVkLSxFJAuOM16XFrykDNj3pG5VQI";
        // localStorage.setItem('token',token)
      });
    },
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "yticon";
  font-weight: normal;
  font-style: normal;
  src: url("./static/yticon2.ttf") format("truetype");
}
body {
  max-width: 420px;
  margin: 0 auto !important;
}
.h-100 {
  background: #f5f5f5 !important;
}
.yticon {
  font-family: "yticon" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-yiguoqi1:before {
  content: "\e700";
}

.icon-iconfontshanchu1:before {
  content: "\e619";
}

.icon-iconfontweixin:before {
  content: "\e611";
}

.icon-alipay:before {
  content: "\e636";
}

.icon-shang:before {
  content: "\e624";
}

.icon-shouye:before {
  content: "\e626";
}

.icon-shanchu4:before {
  content: "\e622";
}

.icon-xiaoxi:before {
  content: "\e618";
}

.icon-jiantour-copy:before {
  content: "\e600";
}

.icon-fenxiang2:before {
  content: "\e61e";
}

.icon-pingjia:before {
  content: "\e67b";
}

.icon-daifukuan:before {
  content: "\e68f";
}

.icon-pinglun-copy:before {
  content: "\e612";
}

.icon-dianhua-copy:before {
  content: "\e621";
}

.icon-shoucang:before {
  content: "\e645";
}

.icon-xuanzhong2:before {
  content: "\e62f";
}

.icon-gouwuche_:before {
  content: "\e630";
}

.icon-icon-test:before {
  content: "\e60c";
}

.icon-icon-test1:before {
  content: "\e632";
}

.icon-bianji:before {
  content: "\e646";
}

.icon-jiazailoading-A:before {
  content: "\e8fc";
}

.icon-zuoshang:before {
  content: "\e613";
}

.icon-jia2:before {
  content: "\e60a";
}

.icon-huifu:before {
  content: "\e68b";
}

.icon-sousuo:before {
  content: "\e7ce";
}

.icon-arrow-fine-up:before {
  content: "\e601";
}

.icon-hot:before {
  content: "\e60e";
}

.icon-lishijilu:before {
  content: "\e6b9";
}

.icon-zhengxinchaxun-zhifubaoceping-:before {
  content: "\e616";
}

.icon-naozhong:before {
  content: "\e64a";
}

.icon-xiatubiao--copy:before {
  content: "\e608";
}

.icon-shoucang_xuanzhongzhuangtai:before {
  content: "\e6a9";
}

.icon-jia1:before {
  content: "\e61c";
}

.icon-bangzhu1:before {
  content: "\e63d";
}

.icon-arrow-left-bottom:before {
  content: "\e602";
}

.icon-arrow-right-bottom:before {
  content: "\e603";
}

.icon-arrow-left-top:before {
  content: "\e604";
}

.icon-icon--:before {
  content: "\e744";
}

.icon-zuojiantou-up:before {
  content: "\e605";
}

.icon-xia:before {
  content: "\e62d";
}

.icon--jianhao:before {
  content: "\e60b";
}

.icon-weixinzhifu:before {
  content: "\e61a";
}

.icon-comment:before {
  content: "\e64f";
}

.icon-weixin:before {
  content: "\e61f";
}

.icon-fenlei1:before {
  content: "\e620";
}

.icon-erjiye-yucunkuan:before {
  content: "\e623";
}

.icon-Group-:before {
  content: "\e688";
}

.icon-you:before {
  content: "\e606";
}

.icon-forward:before {
  content: "\e607";
}

.icon-tuijian:before {
  content: "\e610";
}

.icon-bangzhu:before {
  content: "\e679";
}

.icon-share:before {
  content: "\e656";
}

.icon-yiguoqi:before {
  content: "\e997";
}

.icon-shezhi1:before {
  content: "\e61d";
}

.icon-fork:before {
  content: "\e61b";
}

.icon-kafei:before {
  content: "\e66a";
}

.icon-iLinkapp-:before {
  content: "\e654";
}

.icon-saomiao:before {
  content: "\e60d";
}

.icon-shezhi:before {
  content: "\e60f";
}

.icon-shouhoutuikuan:before {
  content: "\e631";
}

.icon-gouwuche:before {
  content: "\e609";
}

.icon-dizhi:before {
  content: "\e614";
}

.icon-fenlei:before {
  content: "\e706";
}

.icon-xingxing:before {
  content: "\e70b";
}

.icon-tuandui:before {
  content: "\e633";
}

.icon-zuanshi:before {
  content: "\e615";
}

.icon-zuo:before {
  content: "\e63c";
}

.icon-shoucang2:before {
  content: "\e62e";
}

.icon-shouhuodizhi:before {
  content: "\e712";
}

.icon-yishouhuo:before {
  content: "\e71a";
}

.icon-dianzan-ash:before {
  content: "\e617";
}

:root {
  --theme-font-color: $uni-color-primary;
}

view,
scroll-view,
swiper,
swiper-item,
cover-view,
cover-image,
icon,
text,
rich-text,
progress,
button,
checkbox,
form,
input,
label,
radio,
slider,
switch,
textarea,
navigator,
audio,
camera,
image,
img,
video {
  box-sizing: border-box;
  font-size: 16px;
}

page {
  height: 100%;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}
.flex-6 {
  flex: 6;
}
.fs-12 {
  font-size: 12px;
}
.fs-14 {
  font-size: 14px;
}
.fs-16 {
  font-size: 16px;
}
.fs-18 {
  font-size: 18px;
}
.fs-20 {
  font-size: 20px;
}
.fs-22 {
  font-size: 22px;
}
.themeFontColor {
  color: var(--theme-font-color);
}
.themeBGColor {
  background-color: var(--theme-font-color);
}
.clamp {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f8f8f8;
  position: relative;
}
input {
  border: none;
  background: none;
  font-size: 16px;
}
html,
body,
#app {
  height: 100%;
  word-break: break-all;
  background: #f8f8f8;
}
.van-image__img {
  display: inline-block !important;
}
.htmlContent {
  max-width: 100%;
}
.htmlContent img,
.htmlContent image {
  max-width: 100%;
}
</style>
